<template>
  <div class="v-date-input__container">
    <div class="row">
      <div class="col-4">
        <v-input
          :required="required"
          date-input="date"
          type="tel"
          name="day"
          placeholder="Dato"
          :value="dateObj.day"
          error="Indtast gyldig dato"
          description="DD"
          pattern="^(0[1-9]|[12][0-9]|3[01])$"
          :min="1"
          :max="31"
          @input="dateObj.day = $event.target.value"
          :invalid="isInvalid"
        />
      </div>
      <div class="col-4">
        <v-input
          :required="required"
          :value="dateObj.month"
          date-input="month"
          type="tel"
          name="month"
          placeholder="Måned"
          error="Indtast gyldigt måned"
          description="MM"
          pattern="^(0[1-9]|1[0-2])$"
          :min="1"
          :max="12"
          @input="dateObj.month = $event.target.value"
          :invalid="isInvalid"
        />
      </div>
      <div class="col-4">
        <v-input
          :required="required"
          :value="dateObj.year"
          type="tel"
          name="year"
          description="ÅÅÅÅ"
          placeholder="År"
          date-input="year"
          error="Indtast gyldigt år"
          @input="dateObj.year = $event.target.value"
          pattern="^(19|20)\d{2}$"
          :invalid="isInvalid"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "v-date-input",
  props: {
    date: {
      type: [String, Date],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateObj: {
        day: null,
        month: null,
        year: null
      },
      isInvalid: false
    };
  },
  computed: {},
  watch: {
    reset(val) {
      if (val) {
        this.dateObj.day = null;
        this.dateObj.month = null;
        this.dateObj.year = null;
      }
    },
    dateObj: {
      handler(val) {
        if (val.day && val.month && val.year && val.year.length === 4) {
          this.onInput();
        }
      },
      deep: true
    },
    date: {
      immediate: true,
      handler(val) {
        // if there is date in iso format, autofill into input fields
        if (val) {
          const date = moment(val);
          if (date) {
            this.dateObj.day = date.format("DD");
            this.dateObj.month = date.format("MM");
            this.dateObj.year = date.format("YYYY");
          }
        }
      }
    }
  },
  methods: {
    onInput() {
      this.isInvalid = false;
      if (this.dateObj.day && this.dateObj.month && this.dateObj.year) {
        const completeDate = `${this.dateObj.month}/${this.dateObj.day}/${this.dateObj.year}`;
        const date = moment.utc(completeDate, "MM/DD/YYYY").toISOString();
        if (moment(date).isValid()) {
          this.isInvalid = false;
          this.$emit("date", date);
        } else {
          this.isInvalid = true;
        }
      }
    }
  }
};
</script>
<style scoped>
.v-date-input__container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
